module.exports = __webpack_public_path__ + "img/friend1.3d3eeb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/friend1.png
// module id = 5WAo
// module chunks = 1 4 5 6 15